import React, { Suspense } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { skillsList } from "../Utils/Data";

function Skills() {
  return (
    <>
      <Container className="mt-5">
        <Suspense
          fallback={
            <div className="d-flex justify-content-center mt-5">
              <Spinner animation="border" variant="secondary" />
            </div>
          }
        >
          <Row className="justify-content-evenly icons-row">
            {skillsList.map((e) => (
              <Col xs={4} md={2} style={{ margin: "20px" }}>
                <div className="d-flex justify-content-center align-items-center m-2 icon-card">
                  <img
                    key={e.id}
                    src={e.src}
                    alt={e.label}
                    style={{ height: "80px" }}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Suspense>
      </Container>
    </>
  );
}

export default Skills;
